module.exports = __webpack_public_path__ + "img/10.00990c10.svg";